import script from "./ParentStudents.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentStudents.vue?vue&type=script&setup=true&lang=js"

import "./ParentStudents.vue?vue&type=style&index=0&id=0bc4fda7&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bc4fda7"]])

export default __exports__